export default __webpack_public_path__ + "static/media/empty-box.fe679b07.png";